import React, { useState, useMemo } from "react";
import { Container } from "reactstrap";
import { useSelector } from "react-redux";

import { DF_OT0018Context } from "./context";
import GridHeader from "./Grid/GridHeader";
import GridBody from "./Grid/GridBody";

import { fnGetValueByKey } from "../../../helpers/functions";
import withRouter from "../../../components/Common/withRouter";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";

function DF_OT0018(props) {
  document.title = "Defender | Desativar Categoria";

  const { userProfile, isModalPage } = useSelector((state) => ({
    userProfile: state.login.profile,
    isModalPage: state.Layout.isModalPage,
  }));

  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);

  const userId = userProfile?.ID_Usuario;
  const idCategoria = parseParams.get("ID_Categoria");
  const idEmpresaOrigem = parseParams.get("ID_Empresa_Origem");
  const idEmpresaDestino = parseParams.get("ID_Empresa_Destino");

  return (
    <DF_OT0018Context.Provider
      value={{
        userId,
        idCategoria,
        idEmpresaOrigem,
        idEmpresaDestino,
        navigate: props.router.navigate,
      }}
    >
      <div
        className="page-content"
        style={isModalPage ? { padding: "0px", overflow: "hidden" } : {}}
      >
        <Container fluid={true}>
          <GridHeader />
          <GridBody />
        </Container>
      </div>
    </DF_OT0018Context.Provider>
  );
}

export default withRouter(DF_OT0018);